declare global {
  interface Promise<T> {
    result(): Promise<[Error | null, T | null]>;
  }
}

Promise.prototype.result = async function <T>(): Promise<[Error | null, T | null]> {
  try {
    const result = await this;
    return [null, result];
  } catch (error: any) {
    return [new Error(error), null];
    // return [error instanceof Error ? error : new Error(error), null];
  }
};

export async function to<T>(promise: Promise<T>): Promise<[Error | null, T | null]> {
  return promise.result();
}